import React from 'react';
import { useAppSelector } from '../store/hooks';
interface ItemProps {
  darkMode: any
}


const SocialSharing: React.FC<ItemProps> = ({ darkMode }) => {

    const socialPlatforms = useAppSelector((state: any) => state.staticSettingSlice.data);
  return ( 
    <div className={`flex flex-wrap justify-center items-center gap-2 pt-2 pb-2 mb-2 ${darkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'}`}>
      {socialPlatforms?.socials?.map((platform:any) => {
        const iconClasses = "w-10 h-10 object-contain";
        const linkClasses = `inline-block dark:bg-gray-700 rounded-lg shadow-mdx
                             transform transition-transform duration-200 hover:scale-110
                             hover:bg-gray-200 dark:hover:bg-gray-600`;       
        
          return (
            <a target='_blank'
            rel="noreferrer"
              key={platform?.id}
              href={platform?.slug}
              aria-label={`Go to ${platform?.title}`}
              className={linkClasses}>
                <img src={platform.image}
                alt={platform.title}
                className={iconClasses}
              />
            </a>
          );
        
      })}


      {socialPlatforms?.headmobileApp?.map((platform:any) => {
        const iconClasses = "w-10 h-10 object-contain";
        const linkClasses = `inline-block dark:bg-gray-700 rounded-lg shadow-mdx
                             transform transition-transform duration-200 hover:scale-110
                             hover:bg-gray-200 dark:hover:bg-gray-600`;       
        
          return (
            <a target='_blank'
              key={platform?.id}
              href={platform?.slug}
              aria-label={platform?.title}
              className={linkClasses}>
                <img src={platform?.icon}
                alt={platform.title}
                className={iconClasses}
              />
            </a>
          );
        
      })}
    </div>
  );
};

export default SocialSharing;